import React, { FunctionComponent } from 'react';
import { Flex, Box } from 'rebass/styled-components';
import { Button } from '..';
import EditorError from '../Editor/EditorError';

export interface EditModeButtonsProps {
  cancel: () => void;
  save: () => void;
  isValid: boolean;
  isSaving?: boolean;
}

const EditModeButtons: FunctionComponent<EditModeButtonsProps> = (
  {
    cancel, save, isValid, isSaving = false,
  }: EditModeButtonsProps,
) => (
  <Flex justifyContent="space-between" flex={1} ml={2}>
    <Flex flex={1} mr={2} alignItems="center">
      <Box mr={2}>
        <Button variant="secondary" onClick={cancel} disabled={isSaving} data-testid="cancel-button">
          Cancel
        </Button>
      </Box>
      <Box mr={2}>
        <Button variant="primary" onClick={save} data-testid="save-button">
          {`${isSaving ? 'Saving' : 'Save'}`}
        </Button>
      </Box>
      <EditorError isValid={isValid} />
    </Flex>
  </Flex>
);

export default EditModeButtons;
